/**
 * Smooth scroll helper for guided UX (autoscroll after expand / mode change).
 * @param {HTMLElement|null} el
 * @param {number} offset - pixels from top (sticky header)
 */
export function scrollToElement(el, offset = 58) {
  if (!el || typeof window === "undefined") return;
  const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
}

export function isElementInView(el, offset = 58, bottomMargin = 24) {
  if (!el || typeof window === "undefined") return true;
  const rect = el.getBoundingClientRect();
  return rect.top >= offset - 12 && rect.bottom <= window.innerHeight - bottomMargin;
}

export function scrollToElementIfNeeded(el, offset = 58) {
  if (!el || typeof window === "undefined") return;
  if (isElementInView(el, offset)) return;
  scrollToElement(el, offset);
}

export function scrollToElementDelayed(el, offset = 58, delay = 120) {
  if (typeof window === "undefined") return;
  window.setTimeout(() => scrollToElement(el, offset), delay);
}

export function scrollToElementDelayedIfNeeded(el, offset = 58, delay = 120) {
  if (typeof window === "undefined") return;
  window.setTimeout(() => scrollToElementIfNeeded(el, offset), delay);
}

/** Highlight + smooth scroll (correction guided UX). */
export function focusScrollTarget(el) {
  if (!el || typeof window === "undefined") return;
  el.scrollIntoView({ behavior: "smooth", block: "center" });
  el.classList.remove("next-focus");
  void el.offsetWidth;
  el.classList.add("next-focus");
  const focusable = el.matches("button,select,input,textarea")
    ? el
    : el.querySelector("button,select,input,textarea");
  if (focusable) {
    window.setTimeout(() => focusable.focus({ preventScroll: true }), 260);
  }
}
